import React from 'react'
import { useParams } from 'react-router'
import PageHeader from '../../components/page-header'
import DetailsSections from '../../components/details-sections'
import TaskProgress from '../../components/task-progress'
import TaskNotFound from '../../components/task-not-found'
import { useTranslation, useTask } from '../../hooks'
import './_taskDetails.scss'

function TaskDetails() {
  const { i18n } = useTranslation();
  const { taskId } = useParams();
  const { task, details, steps, mapAllowed, origin, destination } = useTask(taskId);

  if (!task) return <TaskNotFound />

  return (
    <div className="container task-details">
      <PageHeader title={i18n('cp_work_order')} to="/order_details" />
      <div className="card task-details__card">
        <DetailsSections title={i18n('cp_appointment_details')} items={details} />
      </div>
      <TaskProgress steps={steps} mapAllowed={mapAllowed} origin={origin} destination={destination} />
    </div>
  )
}

export default TaskDetails
